export enum DOMAIN {
  FOOT_LOCKER = 'FOOT_LOCKER',
  NYKAA_FASHION = 'NYKAA_FASHION',
}
